module.exports = __webpack_public_path__ + "img/mobile-contact-tg.dc421648.webp";